import { Button } from "@suraasa/placebo-ui"
import clsx from "clsx"
import AsyncBuilder from "components/AsyncBuilder"
import { useMemo, useState } from "react"
import { useTimer } from "react-timer-hook"

type Props = {
  resendAt?: string
  text?: string
  onClick: () => Promise<void>
  timerText?: string
  enabled?: boolean
}

function Timer({
  expiryTimestamp,
  onExpire,
}: {
  expiryTimestamp: string
  onExpire: () => void
}) {
  const { seconds, minutes } = useTimer({
    expiryTimestamp: new Date(expiryTimestamp),
    onExpire,
  })

  return (
    <div>
      {`${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`}
    </div>
  )
}

const ResendOTPButton = ({
  resendAt,
  timerText = "You can resend otp after",
  enabled = true,
  text = "Resend",
  ...props
}: Props) => {
  const [expired, setExpired] = useState(false)

  const isTimerActive = useMemo(() => {
    return resendAt && new Date(resendAt) > new Date() && !expired
  }, [resendAt, expired])

  const canResend = enabled && !isTimerActive

  return (
    <AsyncBuilder
      handler={async () => {
        setExpired(false)
        await props.onClick()
      }}
      render={({ onClick, loading }) => (
        <Button
          disabled={!canResend}
          loading={loading}
          variant="text"
          onClick={onClick}
          className={clsx({ "!p-0 text-left": !canResend })}
        >
          {isTimerActive && resendAt ? (
            <div className="flex flex-col items-start sm:flex-row sm:items-center">
              {timerText}&nbsp;
              <Timer
                expiryTimestamp={resendAt}
                onExpire={() => setExpired(true)}
              />
            </div>
          ) : (
            text
          )}
        </Button>
      )}
    />
  )
}

export default ResendOTPButton
